import { IFilterResult } from "@components/filters/filterLib";
import { createContext } from "react";

export const FilterContext = createContext<{
  getColumnFromFilterGroup:(filterGroup: string) => string,
  getFilterGroupDisplayName?: (filterGroup: string, count: number) => string,
  filters: IFilterResult,
  handleFiltersUpdated: (newFilter: IFilterResult) => void,
  handleCancel?: () => void,
  filterOptions: {
    availableFilters: IFilterResult,
    filtersLoaded: boolean
  }
    } | null>(null);
